<template>
    <div class="SC-split__col" v-if="matches.length > 0">

        <div class="caption caption--assoc">{{type}}</div>

        <div class="LiveStadiums">
            <div class="LiveStadiums__caption">Stadiums:</div>
            <ul>
                <li v-for="court in courts">
                    <a href="#" @click.prevent="changeCourt(court)" :class="{ 'selected': court == selectedCourt }">{{parseInt(court) +1}}</a>
                </li>
            </ul>
        </div>

        <div class="Results-matches">

            <score-card v-for="match in matches"
                        :match="match"
                        :flagPath="flagPath"
                        :key="match.id"
                        :detail="detail"
                        mode="live"
                        :data-id="match.id">
            </score-card>

        </div>

        <div class="go-more">
            <a :href="center">Go to score center</a>
        </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import MatchCard from './MatchCard'

    export default {
        props: ['type', 'flag', 'detail', 'center'],
        components: {
            'score-card': MatchCard,
        },
        data() {
            return {
                matches: [],
                feed: [],
                flagPath: this.flag + '/assets/dist/svg/flags/',
                selectedCourt: '',
                courts: []
            }
        },
        created: function () {

            this.getLive()

            let app = this
            setInterval(function () {
                app.getLive()
            }, 15 * 1000, app)

        },
        watch: {
            selectedCourt(newValue, oldValue) {
                this.matches = this.onlyCourtMatches(this.feed, newValue)
            }
        },
        methods: {
            showMatch(match) {
                if (!match.detail) {
                    return false
                }

                if (match.detail.state != 'F') {
                    return true
                }
            },
            changeCourt(court) {
                this.selectedCourt = court
            },
            determineFeedUrl() {

                if (this.type == 'atp') {
                    return window.atp_ip
                } else {
                    return window.wta_ip
                }

            },
            removeFinishedMatches(matches) {
                return matches.filter(function (match) {

                    return match.detail.state != 'F'

                })

            },
            onlyCourtMatches(matches, court) {
                return matches.filter(function (match) {
                    return match.detail.crt == court
                })
            },
            setupCourts(matches) {
                let courts = []

                for (let match of matches) {
                    courts.push(match.detail.crt)
                }

                this.courts = courts
            },
            removeWrongAssoc(matches) {
                if (this.type == 'wta') {
                    return matches
                }
                return matches.filter(function (match) {
                    return (match.id.startsWith('MS') || match.id.startsWith('MD') || match.id.startsWith('QS') || match.id.startsWith('QD'))
                },)
            },
            getLive() {

                let ip = this.determineFeedUrl()

                axios.get(`${ip}/get/${this.type}/live`).then(response => {

                    this.feed = response.data

                    // let liveMatches = this.removeFinishedMatches(response.data)
                    let liveMatches = response.data
                    liveMatches = this.removeWrongAssoc(liveMatches)

                    liveMatches.sort(function (a, b) {
                        return a.detail.crt - b.detail.crt
                    })

                    if (liveMatches.length > 0) {

                        this.setupCourts(liveMatches)

                        if (this.selectedCourt == '') {
                            this.selectedCourt = liveMatches[0].detail.crt
                        }

                        this.matches = this.onlyCourtMatches(liveMatches, this.selectedCourt)


                    } else {

                        this.matches = liveMatches

                    }

                }).catch(function (error) {
                    console.log(error);
                });
            }
        }
    }
</script>